import React from 'react';
interface CTAButtonProps {
  text: string;
  primary?: boolean;
  onClick?: () => void;
  className?: string;
  href?: string;
  icon?: ReactNode;
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}
export function CTAButton({
  text,
  primary = false,
  onClick,
  className = '',
  href,
  icon,
  size = 'medium',
  fullWidth = false
}: CTAButtonProps) {
  // Size classes
  const sizeClasses = {
    small: 'px-4 py-2 text-sm',
    medium: 'px-6 py-3',
    large: 'px-8 py-4 text-lg'
  };
  // Style classes
  const styleClasses = primary ? 'bg-red-600 text-white hover:bg-red-700 shadow-md hover:shadow-lg' : 'bg-white text-red-600 border border-red-600 hover:bg-red-50';
  // Width classes
  const widthClasses = fullWidth ? 'w-full' : '';
  const buttonClasses = `${styleClasses} ${sizeClasses[size]} ${widthClasses} rounded-lg font-semibold transition-all flex items-center justify-center ${className}`;
  // Only create an anchor if href is provided
  if (href) {
    return <a href={href} onClick={onClick} className={buttonClasses} target="_blank" rel="noopener noreferrer" data-id="element-99">
        {text}
        {icon}
      </a>;
  }
  // Otherwise return a regular button
  return <button onClick={onClick} className={buttonClasses} type="button" data-id="element-100">
      {text}
      {icon}
    </button>;
}